import * as React from 'react';

import * as styles from './styles.css';

interface IAbout {
  title: React.ReactElement<unknown>;
  description: React.ReactElement<unknown>;
  brochure: React.ReactElement<unknown>;
}

export const About = ({ title, description, brochure }: IAbout) => {
  return (
    <div data-nav-tab="info/О комплексе" id="info" className={styles['container']}>
      <div className={styles['about']}>
        <div className={styles['title']}>
          {title}
          {brochure}
        </div>
        <div className={styles['description']} data-testid="AboutDescription">
          {description}
        </div>
      </div>
    </div>
  );
};
